import { render, staticRenderFns } from "./ArticlesTable.vue?vue&type=template&id=70d3ad8a&scoped=true"
import script from "./ArticlesTable.vue?vue&type=script&lang=ts"
export * from "./ArticlesTable.vue?vue&type=script&lang=ts"
import style0 from "./ArticlesTable.vue?vue&type=style&index=0&id=70d3ad8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3ad8a",
  null
  
)

export default component.exports